import { configureStore } from './store';
const gloablStore = configureStore(); 
export default gloablStore;